module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.component) ? _c(_vm.component, {
    tag: "component",
    attrs: {
      "note": _vm.note,
      "locked": true,
      "pageWidth": _vm.pageWidth,
      "pageHeight": _vm.pageHeight,
      "selectedScale": _vm.selectedScale,
      "selectedElement": _vm.selectedElement,
      "totalPages": _vm.totalPages
    }
  }) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-705f74d4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/print/notes/wrapper.vue
// module id = 1260
// module chunks = 21